import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Careers.css';

const openings = [
  { id: 1, title: 'Senior PCB Design Engineer', dept: 'Engineering', type: 'Full-Time', location: 'Bangalore', exp: '5–8 years', desc: 'Design high-speed, multilayer PCBs for IoT and embedded systems. Proficiency in Altium Designer required.' },
  { id: 2, title: 'Embedded Firmware Engineer', dept: 'Engineering', type: 'Full-Time', location: 'Bangalore', exp: '3–6 years', desc: 'Develop firmware for ARM Cortex-M microcontrollers, BLE stacks, and RTOS-based applications.' },
  { id: 3, title: 'SMT Process Engineer', dept: 'Manufacturing', type: 'Full-Time', location: 'Bangalore', exp: '3–5 years', desc: 'Optimize SMT processes, manage SPC implementation, and drive yield improvement initiatives.' },
  { id: 4, title: 'Quality Engineer – IPC', dept: 'Quality', type: 'Full-Time', location: 'Bangalore', exp: '2–5 years', desc: 'Lead incoming QC, AOI, and ICT operations. IPC-A-610 CIS certification preferred.' },
  { id: 5, title: 'Supply Chain Manager', dept: 'Operations', type: 'Full-Time', location: 'Bangalore', exp: '5–8 years', desc: 'Manage component sourcing, vendor relationships, and BOM cost optimization for EMS clients.' },
  { id: 6, title: 'Business Development Executive', dept: 'Sales', type: 'Full-Time', location: 'Bangalore / Remote', exp: '2–4 years', desc: 'Drive new client acquisition in EMS and design services. Deep interest in electronics manufacturing preferred.' },
];

const perks = [
  { icon: '🏥', label: 'Health Insurance', desc: 'Comprehensive medical coverage for you and your family.' },
  { icon: '📚', label: 'Learning Budget', desc: 'Annual budget for certifications, courses, and conferences.' },
  { icon: '🍕', label: 'Free Meals', desc: 'Subsidised canteen with breakfast and lunch on all working days.' },
  { icon: '🏋️', label: 'Wellness Allowance', desc: 'Monthly allowance for gym, yoga, or fitness memberships.' },
  { icon: '🌴', label: '30-Day Leave', desc: 'Generous leave policy including casual, sick, and earned leave.' },
  { icon: '📈', label: 'ESOP Eligible', desc: 'Employee stock options available for qualifying roles.' },
];

const depts = ['All', 'Engineering', 'Manufacturing', 'Quality', 'Operations', 'Sales'];

export default function Careers() {
  const [activeDept, setActiveDept] = useState('All');
  const [expanded, setExpanded] = useState(null);

  const filtered = activeDept === 'All' ? openings : openings.filter(o => o.dept === activeDept);

  return (
    <main className="careers-page page-wrapper">
      <section className="page-hero">
        <div className="page-hero__bg" />
        <div className="container page-hero__inner">
          <div className="section-tag" style={{ background: 'rgba(0,194,224,0.15)', color: 'var(--cyan)' }}>Careers</div>
          <h1 className="page-hero__title">Build the Future of <span>Electronics With Us</span></h1>
          <p className="page-hero__subtitle">
            Join a team of engineers, makers, and operators who take pride in building products that reach millions of people worldwide.
          </p>
          <div style={{ marginTop: 32 }}>
            <a href="#openings" className="btn-primary">View Open Roles →</a>
          </div>
        </div>
      </section>

      {/* Culture */}
      <section className="section careers-culture">
        <div className="container">
          <div className="careers-culture-inner">
            <div>
              <div className="section-tag">Life at Zxeon FS</div>
              <h2 className="section-title">More Than a Job.<br /><span>A Craft.</span></h2>
              <p style={{ fontSize: '1rem', color: 'var(--text-secondary)', lineHeight: 1.75, marginBottom: 16 }}>
                At Zxeon FS, we believe that great electronics come from great people who care deeply about their work. We hire for attitude, curiosity, and craft — then invest in making those people even better.
              </p>
              <p style={{ fontSize: '1rem', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
                Whether you're an engineer designing cutting-edge PCBs, an operator running our SMT lines, or a supply chain specialist navigating component markets — your work here directly impacts products that people use every day.
              </p>
            </div>
            <div className="perks-grid">
              {perks.map(p => (
                <div key={p.label} className="perk-card">
                  <span className="perk-icon">{p.icon}</span>
                  <strong>{p.label}</strong>
                  <span>{p.desc}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Openings */}
      {/* <section className="section openings-section" id="openings">
        <div className="container">
          <div className="openings-header">
            <div>
              <div className="section-tag">Open Positions</div>
              <h2 className="section-title">Current <span>Openings</span></h2>
            </div>
            <div className="dept-filters">
              {depts.map(d => (
                <button
                  key={d}
                  className={`dept-filter${activeDept === d ? ' active' : ''}`}
                  onClick={() => setActiveDept(d)}
                >{d}</button>
              ))}
            </div>
          </div>

          <div className="openings-list">
            {filtered.map(job => (
              <div key={job.id} className={`job-card${expanded === job.id ? ' job-card--open' : ''}`}>
                <div className="job-card-header" onClick={() => setExpanded(expanded === job.id ? null : job.id)}>
                  <div className="job-header-left">
                    <h3>{job.title}</h3>
                    <div className="job-meta">
                      <span className="job-badge">{job.dept}</span>
                      <span className="job-detail">📍 {job.location}</span>
                      <span className="job-detail">⏱ {job.exp}</span>
                      <span className="job-detail">💼 {job.type}</span>
                    </div>
                  </div>
                  <div className="job-toggle">{expanded === job.id ? '−' : '+'}</div>
                </div>
                {expanded === job.id && (
                  <div className="job-card-body">
                    <p>{job.desc}</p>
                    <Link to="/contact" className="btn-primary" style={{ marginTop: 16 }}>Apply for This Role →</Link>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="openings-footer">
            <p>Don't see a role that fits? Send your resume to <a href="mailto:careers@zxeonfs.com" className="inline-link">careers@zxeonfs.com</a> — we're always looking for exceptional people.</p>
          </div>
        </div>
      </section> */}

      <section className="cta-banner">
        <div className="container cta-banner__inner">
          <div className="cta-banner__text">
            <h2>Ready to Join <span>Zxeon FS?</span></h2>
            <p>Great products start with great people. We'd love to hear from you.</p>
          </div>
          <div className="cta-banner__actions">
            <a href="mailto:careers@zxeonfs.com" className="btn-primary">Send Your Resume →</a>
            <Link to="/about" className="btn-outline-white">Learn About Us</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
